import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Badge,
} from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

export default function Hero({
  badge,
  title,
  subtitle,
  children,
  withGradient = true,
}) {
  const bgGradient = "linear(to-br, #0F172A, #1E293B, #10B981)";

  return (
    <Box
      bgGradient={withGradient ? bgGradient : undefined}
      bg={!withGradient ? "#F8FAFC" : undefined}
      py={{ base: 16, md: 24 }}
      position="relative"
      overflow="hidden"
    >
      <Container maxW="container.xl">
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <VStack spacing={6} textAlign="center" alignItems="center">
            {badge && (
              <Badge
                colorScheme="green"
                fontSize="sm"
                px={3}
                py={1}
                borderRadius="full"
              >
                {badge}
              </Badge>
            )}

            {title && (
              <Heading
                as="h1"
                size="2xl"
                fontSize={{ base: "2xl", md: "4xl", lg: "6xl" }}
                color={withGradient ? "white" : "#0F172A"}
                lineHeight={1.2}
              >
                {title}
              </Heading>
            )}

            {subtitle && (
              <Text
                fontSize={{ base: "lg", md: "xl" }}
                color={withGradient ? "#FFFFFF" : "#1E293B"}
                maxW="2xl"
              >
                {subtitle}
              </Text>
            )}

            {children && <Box>{children}</Box>}
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
}
